module.exports = __webpack_public_path__ + "static/media/soidukid_ja_piletid.6b244310.png";